import { isRejectedWithValue } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

export const rtkQueryErrorLogger = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const status = action.payload?.status;

    // Ignore 401 Unauthorized errors since they are handled by baseQueryWithReauth
    if (status !== 401) {
      const message =
        action.payload?.data?.message ||
        action.payload?.data ||
        action.payload?.message ||
        "An unexpected network error occurred.";

      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: typeof message === "string" ? message : JSON.stringify(message),
        toast: true,
        position: "top-end",
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
      });
    }
  }

  return next(action);
};
